module.exports = {
          srcSet: __webpack_public_path__ + "82e8f49d8292e7c2535b04cc85646fcd-354.png"+" 354w",
          images:[ {path: __webpack_public_path__ + "82e8f49d8292e7c2535b04cc85646fcd-354.png",width: 354,height: 79}],
          src: __webpack_public_path__ + "82e8f49d8292e7c2535b04cc85646fcd-354.png",
          toString:function(){return __webpack_public_path__ + "82e8f49d8292e7c2535b04cc85646fcd-354.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASElEQVR4nBXGoQ2DYBQGQAb47v1DMAemiLoWgkG0adBNEAjmJ5y6rqrmJCseGJL0SZ7YsSX54uxaaxNeeONXVSMWHPgn+dy/AHdGCctledwVAAAAAElFTkSuQmCC",
          width: 354,
          height: 79
        }